/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_0Inputs */

const en_sch_level_0 = /** @type {(inputs: Sch_Level_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-task`)
};

const de_sch_level_0 = /** @type {(inputs: Sch_Level_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unteraufgabe`)
};

/**
* | output |
* | --- |
* | "Sub-task" |
*
* @param {Sch_Level_0Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_0 = /** @type {((inputs?: Sch_Level_0Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_0Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_0(inputs)
	return en_sch_level_0(inputs)
});